'use strict';

var react = require('react');

// src/hooks/useCookiesState.ts

// src/helper/cookies.ts
function setCookie(key, value, options = {}) {
  if (typeof document === "undefined") return;
  let cookieString = `${key}=${value}`;
  if (options.maxAge) cookieString += `; Max-Age=${options.maxAge}`;
  if (options.expires) cookieString += `; Expires=${options.expires}`;
  cookieString += `; Path=${options.path || "/"}`;
  if (options.domain) cookieString += `; Domain=${options.domain}`;
  if (options.secure) cookieString += "; Secure";
  if (options.sameSite) cookieString += `; SameSite=${options.sameSite}`;
  document.cookie = cookieString;
}
function getCookie(name) {
  if (typeof document === "undefined") return;
  const nameLenPlus = name.length + 1;
  return document.cookie.split(";").map((c) => c.trim()).filter((cookie) => {
    return cookie.substring(0, nameLenPlus) === `${name}=`;
  }).map((cookie) => {
    try {
      return decodeURIComponent(cookie.substring(nameLenPlus));
    } catch (err) {
      try {
        return decodeURIComponent(
          encodeURIComponent(cookie.substring(nameLenPlus))
        );
      } catch (err2) {
        return cookie.substring(nameLenPlus);
      }
    }
  })[0] || void 0;
}
function deleteCookie(key, options = {}) {
  setCookie(key, "", { ...options, maxAge: -1 });
}

// src/hooks/useCookiesState.ts
var ONE_MONTH_IN_MS = 30 * 24 * 60 * 60 * 1e3;
var useCookiesState = (key, defaultValue, expires = ONE_MONTH_IN_MS, { serialize = JSON.stringify, deserialize = JSON.parse } = {}) => {
  const isFirstRender = react.useRef(true);
  const initDefaultValue = () => {
    const data = getCookie(key);
    if (data) {
      return deserialize(data);
    } else {
      deleteCookie(key);
      return defaultValue;
    }
  };
  const [state, setState] = react.useState(initDefaultValue);
  react.useEffect(() => {
    const data = getCookie(key);
    data ? setState(deserialize(data)) : deleteCookie(key);
  }, []);
  const updateCookie = () => {
    const data = getCookie(key);
    data ? setState(deserialize(data)) : deleteCookie(key);
  };
  const prevKeyRef = react.useRef(key);
  react.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const prevKey = prevKeyRef.current;
    if (prevKey !== key) {
      deleteCookie(key);
    }
    prevKeyRef.current = key;
    setCookie(key, serialize(state), {
      expires: new Date(Date.now() + expires),
      sameSite: "strict"
    });
  }, [key, state]);
  return [state, setState, updateCookie];
};

exports.useCookiesState = useCookiesState;
